import { onScopeDispose } from 'vue';

/** Ignore responses from an older refresh/filter or a section that has been left. */
export function useSettingsLoadGuard() {
  let sequence = 0;
  onScopeDispose(() => { sequence += 1; });
  return () => {
    const request = ++sequence;
    return () => request === sequence;
  };
}
